const SourceUrlSuffix = '/stats/rest/index.php?entity=realtime';

export {
  SourceUrlSuffix,
};
